/**
 * @param email {string}
 * @return {string}
 */
module.exports = function validateEmail(email) {
    const error = "Please enter a valid email address";

    if (!email || !email.includes('@')) {
        return error; // Empty email
    }

    return "";
}